import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './intradayProfilePreview.png';

export const intradayProfileDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Intraday Profiles chart is an overview of the symbol&apos;s
                historical trading pattern during the day to help inform timing
                decisions.
            </div>
            <div>
                It compares today&apos;s volume to the historical volume and
                plots the historical spread and price volatility.
            </div>
        </>
    ),
    previews: [{ src: preview, altText: 'intraday-profiles-preview' }],
};
